import { useEffect, useState } from 'react'

export function useImageNaturalSize(url: string | null) {
  const [dims, setDims] = useState<{ w: number; h: number } | null>(null)
  useEffect(() => {
    if (!url) return
    const img = new Image()
    img.onload = () => setDims({ w: img.naturalWidth, h: img.naturalHeight })
    img.onerror = () => setDims(null)
    img.src = url
  }, [url])
  return dims
}
